import React from 'react'
import Associations from '../../associations'

const fields = [{
  name: 'User',
  prop: 'user_id',
  type: 'autocomplete',
  references: 'admin/users',
  referenceProp: 'fullname',
  displayProp: 'name'
}]

const columns = [
  { name: 'ID', prop: 'id' },
  { name: 'Name', prop: 'name' },
  { name: 'Email', prop: 'email' }
]

const SubAccounts = ({ params }) => (
  <Associations
// @ts-ignore
    title='Sub Accounts'
    fields={fields}
    columns={columns}
    baseRecord={{
      institution_id: params.institutionId,
      is_account_holder: false
    }}
    joinApiPath='admin/institution_users'
    associationApiPath='admin/users'
    joinApiQuery={{
      'filters[institution_id]': params.institutionId,
      'filters[is_account_holder]': false
    }}
    associationIdField='user_id'
    viewAssociation={({ user_id: id }) => `/security/users/${id}/edit`}
  />
)

export default SubAccounts
